import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DocumentExportAPIService } from 'src/app/extensions/services/api/documentExport-api.service';
import { TranslateService } from '@ngx-translate/core';
import { base64StringToBlob } from 'blob-util';
import { SpecialOfferAPIService } from 'src/app/extensions/services/api/specialOffer-api.service';
import { isSafari } from 'src/app/extensions/utilities';
import {
  ApexNonAxisChartSeries,
  ApexChart,
  ApexPlotOptions,
  ApexFill,
  ApexStroke,
  ApexStates,
  ChartComponent,
} from 'ng-apexcharts';

type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
  stroke: ApexStroke;
  labels: any[];
  states: ApexStates;
};

@Component({
  selector: 'special-offer-insight',
  templateUrl: './special-offer-insight.component.html',
  styleUrls: ['./special-offer-insight.component.scss'],
  standalone: false,
})
export class SpecialOfferInsightComponent implements OnInit {
  @Input() specialOfferId: string;
  @ViewChild('chartContract') chartContract: ChartComponent;

  specialOfferInsight: app.models.GetSpecialOfferInsightsModel;

  loading = false;

  chartOptions: ChartOptions;
  chartDataLoaded = false;

  constructor(
    private _documentExportAPIService: DocumentExportAPIService,
    private _translateService: TranslateService,
    private _specialOfferAPIService: SpecialOfferAPIService
  ) {}

  ngOnInit(): void {
    this._specialOfferAPIService.getSpecialOfferInsights(this.specialOfferId).subscribe(res => {
      this.specialOfferInsight = res;
      this.chartDataLoaded = true;
      this.updateInsigtsChart();
    });
  }

  updateInsigtsChart() {
    this.chartOptions = {
      series: [
        this.specialOfferInsight.campaignViewCount
          ? Math.round((this.specialOfferInsight.leadsCount / this.specialOfferInsight.campaignViewCount) * 100)
          : 0,
      ],
      chart: {
        height: 350,
        type: 'radialBar',
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 9,
          color: 'var(--primary)',
          opacity: 0.5,
        },
      },
      plotOptions: {
        radialBar: {
          track: {
            background: 'var(--ts-white-3)',
          },
          dataLabels: {
            name: {
              offsetY: 20,
              color: 'var(--text-secondary)',
              fontSize: '20px',
              fontWeight: 'bold',
            },
            value: {
              offsetY: -20,
              color: 'var(--primary)',
              fontSize: '36px',
              fontWeight: 'bold',
              formatter: function (val) {
                return `${val}%`;
              },
            },
          },
        },
      },
      fill: {
        type: 'solid',
        colors: ['var(--primary)'],
      },
      stroke: {
        lineCap: 'round',
      },

      labels: [this._translateService.instant('specialOffers.preview.insights.chartLabel')],
      states: {
        hover: {
          filter: {
            type: isSafari() ? 'none' : 'lighten',
          },
        },
        active: {
          filter: {
            type: 'none',
          },
        },
      },
    };
  }

  exportToXls() {
    this.loading = true;

    this._documentExportAPIService.exportSpecialOffer(this.specialOfferId).subscribe(
      file => {
        let blob = base64StringToBlob(file.response.buffer, file.response.contentType);
        let link = document.createElement('a');
        let objectUrl = URL.createObjectURL(blob);
        link.href = objectUrl;

        let dateTime = new Date();
        let date = dateTime.getFullYear() + '-' + (dateTime.getMonth() + 1) + '-' + dateTime.getDate();
        let time = dateTime.getHours() + '-' + dateTime.getMinutes() + '-' + dateTime.getSeconds();

        let generatedFileName = `i_${date}_${time}`;
        link.download = `${generatedFileName}.${file.response.contentType}`;
        link.click();
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }
}
